import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { DocsChatConversation } from './DocsChatConversation';

const STORAGE_KEY = 'docs-chat-widget';

function readWidgetState(): { isOpen: boolean; isFullscreen: boolean } {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : { isOpen: false, isFullscreen: false };
  } catch {
    return { isOpen: false, isFullscreen: false };
  }
}

export const DocsChatWidget: React.FC = () => {
  const initial = readWidgetState();
  const [isOpen, setIsOpen] = useState(initial.isOpen);
  const [isFullscreen, setIsFullscreen] = useState(initial.isFullscreen);

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ isOpen, isFullscreen }));
  }, [isOpen, isFullscreen]);

  useEffect(() => {
    const open = () => setIsOpen(true);
    window.addEventListener('docs-chat:open', open);
    return () => window.removeEventListener('docs-chat:open', open);
  }, []);

  const panelClassName = `docs-chat-panel ${isFullscreen ? 'docs-chat-panel--fullscreen' : 'docs-chat-panel--floating'}`;

  return (
    <>
      {isOpen && (
        <div className={panelClassName}>
          <DocsChatConversation
            onClose={() => { setIsOpen(false); setIsFullscreen(false); }}
            isFullscreen={isFullscreen}
            onToggleFullscreen={() => setIsFullscreen(f => !f)}
          />
        </div>
      )}
      {!isFullscreen && (
        <button
          className="docs-chat-toggle-btn"
          onClick={() => setIsOpen(!isOpen)}
          title="Documentatie chat"
        >
          {isOpen
            ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            : <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          }
        </button>
      )}
    </>
  );
};

export function registerDocsChatWidget(containerId: string): void {
  const container = document.getElementById(containerId);
  if (!container) return;

  createRoot(container).render(<DocsChatWidget />);
}
